import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil} from 'rxjs';
import { environment } from 'src/environments/environment';
import { Plan } from '../common/models/plan';
import { StepStatus } from '../common/models/stepStatus';
import { User } from '../common/models/user';
import { PlanService } from '../common/services/plan.service';
import { SharedService } from '../common/services/shared.service';
import { StepStatusService } from '../common/services/step-status.service';
import { DialogExamplePlanComponent } from '../dialogs/dialog-exampleplan/dialog-exampleplan.component';
import {CompetencyService} from "../common/services/competency.service";
import {Competency} from "../common/models/competency";
import {PlanEditService} from "../common/services/plan-edit.service";
import {Router} from "@angular/router";
import { LearningResourceService } from '../common/services/learning-resource.service';
import * as moment from "moment";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})

export class DashboardComponent implements OnInit, OnDestroy {

  user: User;
  plan: Plan;
  step: StepStatus;
  c_percent: number;
  reflectionsPlanId: string;

  label: string;
  isComplete: boolean;
  isLoading = true;
  SavedCompetency :Competency[] = [];
  enableReset = (environment.EnableReset.toLowerCase() === 'enabled');
  enableLearningResources = (environment.EnableLearningResources.toLowerCase() === 'enabled');
  submissionDeadlineDate: string = null;
  yearEndReflectionsStartDate: string = null;

  onDestroy$: Subject<boolean> = new Subject();

  constructor(private planService: PlanService, private stepStatusService: StepStatusService, private sharedService: SharedService, private competencyService: CompetencyService, public dialog: MatDialog, private planEditService: PlanEditService, private router: Router, private learnignResourceService: LearningResourceService) { }

  ngOnInit(): void {
    document.getElementsByTagName('mat-sidenav-content')[0]?.scrollTo(0, 0);
    this.sharedService.planUnderReflection$.pipe(takeUntil(this.onDestroy$)).subscribe(r => {
      this.reflectionsPlanId = r;
    });
    this.sharedService.user$.pipe(takeUntil(this.onDestroy$)).subscribe(r => {
      this.user = r;
      if(r) {
        this.updateCompetencies(r.Id)
        this.sharedService.plan$.pipe(takeUntil(this.onDestroy$)).subscribe(p => {
          this.plan = p;
          if (p) {
            this.stepStatusService.getStep(r.Id, p.Id).subscribe(r => {
              this.step = r
              this.isLoading = false;
            });
            this.updateProgress();
            this.updateSubmissionDeadlineDate();
            this.updateYearEndReflectionsStartDate();
          }
        });
      }
    });
  }

  openExampleDialog() {
    this.dialog.open(DialogExamplePlanComponent, {
      width: '875px',
      height: 'auto',
      maxHeight: '80vh',
      panelClass: 'learn-more',
      ariaLabelledBy: 'sample-plan-desc'
    });
  }

  updateProgress() {
    let total = 0;
    let completed = 0;
    if(this.plan?.Status === 'Complete') {
      this.plan?.Competencies?.forEach(function (competency) {
      competency.Activities?.forEach(function (activity) {
        total++;
        if (activity.Status === 2) {
          completed++;
        }
      });
    });
    if (completed == 0)
      this.c_percent = 0
    else
      this.c_percent = Math.ceil((completed / total) * 100);
    }

  }

  updateCompetencies(userId: string) {
    this.SavedCompetency = [];
    this.competencyService.getCompetenciesByUserId(userId).subscribe((value) => {
      if(value) {
        this.SavedCompetency = value
      }
    } );
  }

  reset() {
    this.isLoading = true
    this.stepStatusService.deleteStep(this.user.Id, this.plan.Id).subscribe(() => {
      this.planService.deletePlan(this.plan).subscribe(() => setTimeout(() => window.location.reload(), 2000));
    });
  }

  redirectToEditPlan(): void{
    this.planEditService.setIsEditing(true, 3, this.plan.PlanYear);
    this.router.navigateByUrl('app/selfassessment');
  }

  updateSubmissionDeadlineDate(): void {
    if (this.plan.SubmissionDeadlineDate && this.plan.PlanPeriodStartDate) {
      const dateNow = moment().startOf('day');
      const deadlineDate = moment(this.plan.SubmissionDeadlineDate).startOf('day')
      const planPeriodStartDate = moment(this.plan.PlanPeriodStartDate).startOf('day');
      const isBeforeFourWeeksAfterDeadline = dateNow.diff(deadlineDate, 'day') <= 28;
      const isAfterPeriodStart = dateNow.diff(planPeriodStartDate, 'day') >= 0;

      this.submissionDeadlineDate = isBeforeFourWeeksAfterDeadline && isAfterPeriodStart ?
        moment(this.plan.SubmissionDeadlineDate).format("MMMM D") : null;
    }
  }

  updateYearEndReflectionsStartDate(): void {
    if (this.plan.YearEndReflectionStartDate) {
      this.yearEndReflectionsStartDate = moment(this.plan.YearEndReflectionStartDate).format("MMMM D");
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.unsubscribe();
  }
}
